import { Injectable } from '@angular/core';
import { MonitorInteractionItem } from '@app/models';
import { TimelineItem } from '../../_components/timeline-list/timeline-list.component';

@Injectable({ providedIn: 'root' })
export class TimelineService {
  getTimelineItemFromMonitorInteraction(
    monitorInteraction: MonitorInteractionItem
  ): TimelineItem[] {
    const timelineItems: TimelineItem[] = [];

    // Explanation
    // if (monitorInteraction.explanation) {
    //   timelineItems.push({
    //     date: monitorInteraction.registerDate,
    //     title: monitorInteraction.userMonitor?.name || monitorInteraction.interaction.userMonitor?.name || '',
    //     content: monitorInteraction.explanation
    //   });
    // }
    // Contestations
    if (
      monitorInteraction.contestations &&
      monitorInteraction.contestations.length > 0
    ) {
        monitorInteraction.contestations.forEach(contestation => {
          timelineItems.push({
            date: contestation.registerDate,
            title: contestation.user.name,
            content: contestation.explanation,
            status: contestation.status.name,
            minuteSelected: this.maskMinuteSelected(contestation.minuteSelected),
            fileInfo: contestation.fileInfo,
            file: contestation.file,
            createdByAi: contestation.createdByAi,
            validatedBy: contestation.validatedBy?.name || null,
            contestationId: contestation.id,
            needsValidation: contestation.createdByAi === true && !contestation.validatedBy,
          });
        });
    }

    return timelineItems;
  }

  maskMinuteSelected(time: string): string | null {
    if (!time) return null;
    time = time.replace(/\D/g, '').padStart(6, '0');
    if (time.length !== 6) return null;
    const masked = `${time.slice(0, 2)}:${time.slice(2, 4)}:${time.slice(4, 6)}`;
    return masked;
  }

  unmaskMinuteSelected(masked: string): string | null {
    if (!masked) return null;
    const unmasked = masked.replace(/\D/g, '').padStart(6, '0');
    return unmasked.length === 6 ? unmasked : null;
  }
}
